import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-plus\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>icon24/plus</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-plus_icon24-symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-plus_icon24/plus\" fill=\"#000000\">\n            <rect id=\"icon-plus_Rectangle\" x=\"4\" y=\"10\" width=\"16\" height=\"4\" />\n            <rect id=\"icon-plus_Rectangle\" transform=\"translate(12.000000, 12.000000) rotate(-270.000000) translate(-12.000000, -12.000000) \" x=\"4\" y=\"10\" width=\"16\" height=\"4\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/plus.svg
// module id = f+Cd
// module chunks = 54